const baseConfig = {
  dcbService: process.env.VUE_APP_DCB_SERVICE,
  fantasyService: process.env.VUE_APP_FANTASY_SERVICE,
  fantasyGameEngine: process.env.VUE_APP_FANTASY_GAME_ENGINE,
  triviaService: process.env.VUE_APP_TRIVIA_SERVICE,
  triviaMigrationToken: process.env.VUE_APP_TRIVIA_MIGRATION_TOKEN,
  utilsService: process.env.VUE_APP_UTILS_SERVICE,
  upstreamService: process.env.VUE_APP_UPSTREAM_SERVICE,
  authHeader: process.env.VUE_APP_AUTHORIZATION_HEADERS,
  authHeaderUnsubscribe: process.env.VUE_APP_AUTHORIZATION_HEADER_UNSUBSCRIBE
}

const ENVIRONMENT_OVERRIDES = {
  development: {
    azureBlobUrl: 'https://sportshub-dev.blob.core.windows.net',
    environment: 'development'
  },
  production: {
    azureBlobUrl: 'https://sportshub.blob.core.windows.net',
    environment: 'production'
  }
}

function detectEnvironment() {
  const origin = window.location.origin
  if (origin.includes('localhost') || origin.includes('127.0.0.1')) return 'development'
  return 'production'
}

function getEnvironmentConfig() {
  const env = detectEnvironment()
  return { ...baseConfig, ...ENVIRONMENT_OVERRIDES[env] }
}

export default getEnvironmentConfig()
